import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BellIcon from "../assets/images/icons/bell.svg";
import UserIcon from "../assets/images/icons/user.svg";
import LogoutIcon from "../assets/images/icons/log-out.svg";
import { logoutUser } from "../redux/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import API from "../API";
import { trackClick, trackClickWithUser } from "../utility/analytics";
import { CART_UPDATED_EVENT } from "../utility/cartEvents";
import { SHOP_PAGES } from "../utility/shopLinks";


export const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation(); // 👈 current path ke liye
  const [cartCount, setCartCount] = useState(0);

  const userInfo = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  // Active check helper
  const isActive = (path) => location.pathname === path;

  // Active style (underline + color)
  const activeStyle = (path) => ({
    color: isActive(path) ? "#0d6efd" : "inherit",
    fontWeight: isActive(path) ? "600" : "400",
    borderBottom: isActive(path) ? "2px solid #0d6efd" : "2px solid transparent",
    paddingBottom: "2px",
    transition: "all 0.2s ease",
  });

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("currentSeries");
    localStorage.removeItem("persist:root");
    navigate("/login");
  };

  const fetchCartCount = async () => {
    try {
      const res = await API.get("/user/cart");
      setCartCount(res.data.data.length || 0);
    } catch (err) {
      console.log(err);
    }
  };

  // 🛒 Cart count: page badalne pe + cart me add/remove hone pe refresh
  // (pehle sirf pehli baar load hota tha, isliye login / add ke baad purana count dikhta tha)
  const isLoggedIn = !!userInfo;

  useEffect(() => {
    if (isLoggedIn) {
      fetchCartCount();
    } else {
      setCartCount(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, location.pathname]);

  useEffect(() => {
    const onCartUpdated = () => {
      if (localStorage.getItem("token")) fetchCartCount();
    };
    window.addEventListener(CART_UPDATED_EVENT, onCartUpdated);
    return () => window.removeEventListener(CART_UPDATED_EVENT, onCartUpdated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="top-header sticky-top shadow-sm">
      <div className="announcement-bar bg-primary py-2">
        <div className="container-xl">
          <div className="discription fs-12 text-white text-center">
            You're exploring the <span className="fw-semibold text-danger">Beta version</span>. Some features may be handled manually.
          </div>
        </div>
      </div>

      <nav className="navbar navbar-light bg-white border-bottom navbar-expand-lg py-1" data-bs-theme="light" style={{ minHeight: "61px" }}>
        <div className="container-xl">
          {/* Logo */}
          <Link className="navbar-brand logo-wrapper text-center" to={SHOP_PAGES.home}>
            <img src={require("../assets/images/logo2.png")} alt="Logo" className="img-fluid" />
          </Link>

          {/* Mobile toggle */}
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTopHeader" aria-controls="offcanvasTopHeader">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="offcanvas bg-theme2 offcanvas-start border-0" tabIndex="-1" id="offcanvasTopHeader" aria-labelledby="offcanvasTopHeaderLabel">
            <div className="offcanvas-header bg-primary">
              <h5 className="offcanvas-title text-white">Menu</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav menu-link-nav align-items-center justify-content-end flex-grow-1 gap-2">
                <>
                  <li className="nav-item">
                    <Link
                      to={'/market-Place'}
                      title="marketPlace"
                      className="nav-link p-0"
                      style={activeStyle('/market-Place')}
                      onClick={() => trackClick("header_marketplace_click", { location: "header" })}
                    >
                      MarketPlace
                    </Link>
                  </li>

                  {(!userInfo || userInfo.userType === "admin" || userInfo.userType === "user") && (
                    <li className="nav-item">
                      <button
                        className="nav-link p-0 btn btn-link text-decoration-none"
                        style={activeStyle('/subscriptions-plan')}
                        onClick={() => {
                          trackClick("header_subscription_plan_click", { location: "header" });
                          navigate("/subscriptions-plan");
                        }}
                      >
                        Pricing
                      </button>
                    </li>
                  )}

                  {userInfo && (userInfo.userType === "admin" || userInfo.userType === "user") && (
                    <li className="nav-item">
                      <button
                        className="nav-link p-0 btn btn-link text-decoration-none"
                        title="create-comic"
                        style={activeStyle('/create-comic')}
                        onClick={() => {
                          trackClickWithUser("create_comics_click", { location: "header" });
                          navigate("/create-comic");
                        }}
                      >
                        Create Comics
                      </button>
                    </li>
                  )}
                </>
              </ul>

              <ul className="navbar-nav icons-nav align-items-center justify-content-end flex-grow-1 gap-3">

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "moderator") && (
                  <li className="nav-item">
                    <Link to={'/super-admin'} title="super-admin" className="nav-link p-0" style={activeStyle('/super-admin')}>
                      <i className="bi bi-grid-fill"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "moderator") && (
                  <li className="nav-item">
                    <Link to={'/allUsers'} title='allUsers' className="nav-link p-0" style={activeStyle('/allUsers')}>
                      <i className="bi bi-people-fill"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "moderator") && (
                  <li className="nav-item">
                    <Link to={'/contactList'} title="contactList" className="nav-link p-0" style={activeStyle('/contactList')}>
                      <i className="bi bi-envelope-fill"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin") && (
                  <li className="nav-item">
                    <Link to={'/subjectlist'} title="subjectlist" className="nav-link p-0" style={activeStyle('/subjectlist')}>
                      <i className="bi bi-list-ul"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "user") && (
                  <li className="nav-item">
                    <Link to={'/my-comics'} title="my-comics" className="nav-link p-0" style={activeStyle('/my-comics')} onClick={() => trackClick("header_my_comics_click", { location: "header" })}>
                      <i className="bi bi-book-half"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "user") && (
                  <li className="nav-item">
                    <Link to={'/institute-dashboard'} title="institute-dashboard" className="nav-link p-0" style={activeStyle('/institute-dashboard')}>
                      <i className="bi bi-speedometer2"></i>
                    </Link>
                  </li>
                )}

                <li className="nav-item">
                  <Link to={'/cart'} title="cart" className="nav-link p-0" style={activeStyle('/cart')} onClick={() => trackClick("my_cart_click", { location: "header", cart_count: cartCount })}>
                    <div className="position-relative">
                      <i className="bi bi-cart-fill fs-5"></i>
                      {cartCount > 0 && (
                        <span
                          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                          style={{ fontSize: "10px" }}
                        >
                          {cartCount}
                        </span>
                      )}
                    </div>
                  </Link>
                </li>

                {userInfo && (userInfo.userType === "admin") && (
                  <li className="nav-item">
                    <Link to={'/adUnitManager'} title="ComicRevenueReport" className="nav-link p-0" style={activeStyle('/adUnitManager')}>
                      <i className="bi bi-graph-up-arrow"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin") && (
                  <li className="nav-item">
                    <Link to={'/coupon'} title="coupon" className="nav-link p-0" style={activeStyle('/coupon')}>
                      <i className="bi bi-ticket-perforated"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "parent") && (
                  <li className="nav-item">
                    <Link to={'/parent/manage-children'} title='manage-children' className="nav-link p-0" style={activeStyle('/parent/manage-children')}>
                      <i className="bi bi-speedometer2"></i>
                    </Link>
                  </li>
                )}

                {userInfo && (userInfo.userType === "admin" || userInfo.userType === "user" || userInfo.userType === "moderator" || userInfo.userType === "parent") ? (
                  <Dropdown align="end" className="account-menu">
                    <Dropdown.Toggle variant="white" className="bg-transparent border-0 p-0">
                      <div className="chip-wrapper">
                        <div className="chip-img bg-secondary bg-opacity-25 d-flex align-items-center justify-content-center rounded-circle overflow-hidden">
                          <img className="w-100 h-100" src={require("../assets/images/avatar.png")} alt="User" />
                        </div>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="text-theme3 shadow-sm rounded-3">
                      <div className="user-info text-theme3 pb-1 px-3">
                        <div className="user-info text-start text-truncate">
                          <div className="username fs-14 fw-semibold text-black text-opacity-75 text-capitalize">
                            {userInfo?.firstname || userInfo?.username || "User"}
                          </div>
                          <div className="user-email fs-12 text-muted text-lowercase text-truncate">
                            {userInfo?.email || "unknown@example.com"}
                          </div>
                        </div>
                      </div>
                      <Dropdown.Divider className="my-1" />

                      <Dropdown.Item className="text-theme3" as={Link} to="/my-account">
                        <img src={UserIcon} alt="User Icon" className="img-fluid" /> Profile
                      </Dropdown.Item>

                      <Dropdown.Divider className="my-1" />

                      <Dropdown.Item as={Link} to="/mybundleList" className="text-theme3">
                        <i className="bi bi-key-fill me-2"></i> My Bundle List
                      </Dropdown.Item>

                      <Dropdown.Item as={Link} to="/changepassword" className="text-theme3">
                        <i className="bi bi-key-fill me-2"></i> Change Password
                      </Dropdown.Item>

                      <Dropdown.Item onClick={handleLogout} className="text-theme3">
                        <img src={LogoutIcon} alt="Logout Icon" className="img-fluid" /> Log out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <li className="nav-item">
                    <Link to={'/login'} className="nav-link d-flex align-items-center gap-2 p-0">
                      <img src={UserIcon} alt="User Icon" className="img-fluid" />
                      <span className="text-body d-block d-lg-none">Login/Register</span>
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};
